// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemEditorTabMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ItemEditorTabMetadataQuery = { __typename?: 'Query', enumDetails: { __typename?: 'AllEnumDetails', designPackageLocation: Array<{ __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation, name: string }> } };


export const ItemEditorTabMetadataDocument = gql`
    query ItemEditorTabMetadata {
  enumDetails {
    designPackageLocation {
      code
      name
    }
  }
}
    `;

/**
 * __useItemEditorTabMetadataQuery__
 *
 * To run a query within a React component, call `useItemEditorTabMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemEditorTabMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemEditorTabMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemEditorTabMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemEditorTabMetadataQuery, ItemEditorTabMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemEditorTabMetadataQuery, ItemEditorTabMetadataQueryVariables>(ItemEditorTabMetadataDocument, options);
      }
export function useItemEditorTabMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemEditorTabMetadataQuery, ItemEditorTabMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemEditorTabMetadataQuery, ItemEditorTabMetadataQueryVariables>(ItemEditorTabMetadataDocument, options);
        }
// @ts-ignore
export function useItemEditorTabMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ItemEditorTabMetadataQuery, ItemEditorTabMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemEditorTabMetadataQuery, ItemEditorTabMetadataQueryVariables>;
export function useItemEditorTabMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemEditorTabMetadataQuery, ItemEditorTabMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemEditorTabMetadataQuery | undefined, ItemEditorTabMetadataQueryVariables>;
export function useItemEditorTabMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemEditorTabMetadataQuery, ItemEditorTabMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemEditorTabMetadataQuery, ItemEditorTabMetadataQueryVariables>(ItemEditorTabMetadataDocument, options);
        }
export type ItemEditorTabMetadataQueryHookResult = ReturnType<typeof useItemEditorTabMetadataQuery>;
export type ItemEditorTabMetadataLazyQueryHookResult = ReturnType<typeof useItemEditorTabMetadataLazyQuery>;
export type ItemEditorTabMetadataSuspenseQueryHookResult = ReturnType<typeof useItemEditorTabMetadataSuspenseQuery>;
export type ItemEditorTabMetadataQueryResult = ApolloReactCommon.QueryResult<ItemEditorTabMetadataQuery, ItemEditorTabMetadataQueryVariables>;